import {
  Container,
  ContentLayout,
} from "@cloudscape-design/components";
import { Mode } from "@cloudscape-design/global-styles";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import SeriesNav from "../../../components/series-navbar/series-nav";
import * as awsui from "@cloudscape-design/design-tokens";
import { useMediaQuery } from 'react-responsive';
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { CustomButton } from "../../../components/buttons";
import GetSeriesContent from "../get-series-content";
import Rules from "./rules";
import Gallery from "./gallery";
import Series from "./series";
import Register from './register';
import Results from "./results";
import Calendar from "./calendar";
import DriversAndTeams from "./teams";
import Stats from "./stats";
import Qualifying from "./qualifying";


export default function Trinations_Series() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    theme, setTheme, 
    density, setDensity,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})


  return (
    <>
      <center>
        <div className="body-content">
          <ContentLayout
            header={
              <div className="series-header-container">
                <img 
                  className="series-header-img"
                  src={theme === Mode.Light ? "/images/trinations/tri-header-light.png" : "/images/trinations/tri-header-light.png"}
                />
              </div>
            }
          >
            <Container>
              <SeriesNav />
            </Container>
          </ContentLayout>
        </div>
        {GetSeriesContent(seriesContent, Series, Results, Calendar, Rules, DriversAndTeams, Stats, Gallery, Register, Qualifying )}
      </center>
    </>    
  );
}
